// extracted by mini-css-extract-plugin
module.exports = {"info_box_container":"InfoBoxContainer_info_box_container__1CSWF"};